import { useQuery } from '@tanstack/react-query';
import { api } from './api-client';
import type { TimesheetVisibilityStatus } from './types';

// Effective Timesheet visibility for the current user. Polled like useMe so the sidebar,
// routes and settings rail react within ~a minute of an admin flipping the toggle.
export function useTimesheetVisibility() {
  return useQuery({
    queryKey: ['timesheet-visibility'],
    queryFn: () => api.get<TimesheetVisibilityStatus>('/v1/timesheet/visibility'),
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
}
